import React from "react";

const SectionHeading = ({ overline, title, subtitle, align = "left", className = "" }) => {
  return (
    <div
      className={`${align === "center" ? "text-center mx-auto" : "text-left"} max-w-3xl ${className}`}
    >
      {overline && (
        <span className="inline-block text-xs sm:text-sm uppercase tracking-[0.22em] text-primary font-semibold">
          {overline}
        </span>
      )}
      {title && (
        <h2 className="mt-4 font-heading font-medium text-3xl sm:text-4xl lg:text-5xl leading-[1.1] text-ink-900">
          {title}
        </h2>
      )}
      {subtitle && (
        <p className="mt-5 text-ink-700 text-base sm:text-lg leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
